<template>
  <!-- ---------------------------------------- LOADER ---------------------------------------- -->
  <v-container
    v-if="step === 0"
    fill-height
    class="d-flex justify-center flex-column"
  >
    <v-progress-circular indeterminate></v-progress-circular>

    <div class="mt-2">Chargement...</div>
  </v-container>

  <!-- ---------------------------------------- HEADER ---------------------------------------- -->
  <v-container class="py-12" v-else>
    <div class="text-center mb-12">
      <h1 class="text-h4 text-sm-h3">
        {{ step === 3 ? 'Succès' : 'Postulation' }}
      </h1>

      <div class="subtitle-1 text--secondary mt-2">
        {{ headerSubText }}
      </div>

      <template v-if="step === 3">
        <v-img
          height="200"
          class="mt-6 mb-12"
          contain
          :src="require('@/assets/undraw_winners_ao2o.svg')"
        ></v-img>

        <v-btn
          color="primary"
          class="pa-6"
          to="/vacant-jobs"
        >
          Emplois Vacants
        </v-btn>
      </template>
    </div>

    <!-- ------------------------------------- JOB RESUME ------------------------------------- -->
    <job-resume
      v-if="step === 1"
      :job="job"
      @confirm-next="next"
    ></job-resume>

    <!-- ------------------------------------- APPLY CARD ------------------------------------- -->
    <apply-card
      v-else-if="step === 2"
      :job="job"
      @confirm-sending="next"
    ></apply-card>
  </v-container>
</template>

<script>
import JobResume from '@/components/apply/JobResume.vue';
import ApplyCard from '@/components/apply/ApplyCard.vue';

const axios = require('axios').default;

export default {
  name: 'Apply',

  props: {
    id: String,
  },

  components: {
    'job-resume': JobResume,
    'apply-card': ApplyCard,
  },

  data: () => ({
    job: {},
    step: 0,
  }),

  created() {
    this.getJob();
  },

  methods: {
    async getJob() {
      try {
        const response = await axios.get(`emplois_vacants/${this.id}`);
        this.job = response.data;
        this.next();
      } catch (error) {
        this.$store.commit('SET_SNACKBAR', {
          isActive: true,
          text: 'Une erreur est survenue, rechargez la page',
        });
      }
    },

    next() {
      this.step += 1;
    },
  },

  computed: {
    headerSubText() {
      if (this.step === 1) return 'Continuez pour postuler à cet emploi vacant';
      if (this.step === 3) return 'Votre candidature a bien été envoyée';
      return 'Introduisez les informations demandées pour envoyer votre postulation';
    },
  },
};
</script>
